import { useTranslation } from "react-i18next";
import { Copy } from "lucide-react";
import { toast } from "sonner";

export const CodeBlock = ({ label, code, testId }) => {
  const { t } = useTranslation();
  return (
    <div dir="ltr" className="min-w-0">
      <div className="mb-2 flex items-center justify-between gap-3" dir="auto">
        <p className="label-xs">{label}</p>
        <button
          type="button"
          data-testid={`${testId}-copy`}
          onClick={() => {
            navigator.clipboard?.writeText(code);
            toast.success(t("api.guide.copied"));
          }}
          className="flex items-center gap-1.5 rounded-xl border border-border/60 px-3 py-1.5 text-[11px] font-bold text-muted-foreground shadow-neu-sm hover:text-primary"
        >
          <Copy className="h-3.5 w-3.5" /> {t("api.guide.copy")}
        </button>
      </div>
      <pre
        data-testid={testId}
        className="max-w-full overflow-x-auto whitespace-pre-wrap break-words rounded-2xl border border-border/50 p-4 font-mono text-[11px] leading-relaxed shadow-neu-in sm:whitespace-pre"
      >
        {code}
      </pre>
    </div>
  );
};
